module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[24]389.cdaba3c.woff2";